<template>
    <div style="display: flex; height: calc(100vh - 71px)">
        <!-- 主内容区域 -->
        <div style="flex: 1">
            <!-- 主要内容放在这里 -->
            <el-button v-show="false" id="btnEcdocSaved" type="default" @click="btnEcdocSavedClick" />
            <el-button v-show="false" id="windowOpen" type="default" @click="windowOpen" />

            <ecweboffice v-if="ecweboffice && bodyFileEditor === 2 && officeType === 'ech5'" ref="ecweboffice" style="width: 100%" :editor-url="editorUrl" />
        </div>

        <!-- 右侧插槽区域 -->
        <div style="background-color: #fff">
            <slot name="right-sidebar"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModuleTextEditor',
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        wfAttachUrl: { type: String, default: 'wfInstance/wfBusiAttach' },
        officeType: { type: String, default: 'ech5' },
        bodyFileEditor: { type: Number, default: 0 },
        curTN: {
            type: Object,
            default: function () {
                return null
            }
        }
    },
    data() {
        return {
            bodyFileUrl: '',
            bodyFileCanEdit: 0,
            ecweboffice: false,
            waiting: false,
            editorUrl: '', // 编辑地址
            mbDownUrl: '' // 模版
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$options.components['ecweboffice'] = this.$loadComponent('@/wapp/workflow/webOffice/ecweboffice')

        if (this.curTN === null) this.curTN = this.$vnode.context.curTN

        this.$bus.on('btnOpenWordClick', this.btnOpenWordClick)
        this.$bus.on('btnNoTitleModifyFlTypeClick', this.btnNoTitleModifyFlTypeClick)
        this.$bus.on('selectContractTemplate', this.selectContractTemplate)
    },
    beforeDestroy() {
        this.$bus.off('btnOpenWordClick', this.btnOpenWordClick)
        this.$bus.off('btnNoTitleModifyFlTypeClick', this.btnNoTitleModifyFlTypeClick)
        this.$bus.off('selectContractTemplate', this.selectContractTemplate)
    },
    mounted() {},
    methods: {
        /**
         * 选择合同模版事件
         */
        selectContractTemplate($scope) {
            this.mbDownUrl = 'htgl/htmb/'
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                // params: { 'orderBy': 'sortNo,name' }, // 模版排序
                // data: [{ 'compare': '=', 'field': 'orgCode', 'value': $scope.wfInstance.orgCode }, { 'compare': '=', 'field': 'status', 'value': 1 }],  // 模版状态
                data: [{ compare: '=', field: 'orgCode', value: $scope.wfInstance.orgCode }],
                url: 'htgl/htmb/querydata'
            }).then((res) => {
                if (res.code === 'success') {
                    res.body.listdata.forEach(function (item) {
                        item.value = item.id
                        item.text = item.templateName
                    })

                    this.$bus.emit(
                        'openListitemDialog',
                        this.$tx('gwgl.messages.selectModuleTip', '选择合同模版'),
                        res.body.listdata,
                        (rst) => {
                            if (rst.code === 'success') {
                                const htmb = res.body.listdata.filter((item) => {
                                    if (item.id === rst.value) return true
                                })
                                $scope.vo.htmbId = htmb[0].id
                                $scope.vo.htmbName = htmb[0].templateName
                                // 模版套用调用
                                if ($scope.wfInstance.haveDoc === 2) {
                                    // 再次套红  secondRed
                                    this.$confirm(this.$tx('gwgl.messages.haveModule', '该合同已经有模版！') + `<br>` + this.$tx('gwgl.messages.haveModule2', '是否替换当前模版？'), this.$tx('common.confirmOperate', '确认操作'), { type: 'warning', dangerouslyUseHTMLString: true })
                                        .then(() => {
                                            this.btnOpenWordClick($scope)
                                        })
                                        .catch(() => {
                                            // 处理选择否的情况
                                            $scope.embeddedEditorToggle(false)
                                            return
                                        })
                                } else {
                                    this.btnOpenWordClick($scope)
                                }
                            } else {
                                $scope.embeddedEditorToggle(false)
                            }
                        },
                        $scope.vo.htmbId,
                        this.$tx('gwgl.components.contractModule', '合同模版'),
                        this.$tx('gwgl.components.selectNewM', '请选择新的合同模版：')
                    )
                } else {
                    $scope.embeddedEditorToggle(false)
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 自定义套红按钮 -- NoTitle 模式
         * @param {*} $scope
         */
        btnNoTitleModifyFlTypeClick($scope) {
            this.mbDownUrl = 'gwgl/fwmb/'
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { orderBy: 'sortNo,name' },
                data: [
                    { compare: '=', field: 'orgCode', value: $scope.wfInstance.orgCode },
                    { compare: '=', field: 'status', value: 1 }
                ],
                url: 'gwgl/fwmb/querydata'
            }).then((res) => {
                if (res.code === 'success') {
                    res.body.listdata.forEach(function (item) {
                        item.value = item.id
                        item.text = item.name
                    })

                    this.$bus.emit(
                        'openListitemDialog',
                        this.$tx('gwgl.components.updateGwType', '修改公文类型'),
                        res.body.listdata,
                        (rst) => {
                            if (rst.code === 'success') {
                                const gwmb = res.body.listdata.filter((item) => {
                                    if (item.id === rst.value) return true
                                })

                                $scope.vo.flWord = gwmb[0].fileWord
                                $scope.vo.flFormName = gwmb[0].formTitle
                                $scope.vo.flRedTitle = gwmb[0].fileHeader
                                $scope.vo.gwmbId = gwmb[0].id
                                $scope.vo.flType = gwmb[0].name

                                // 套红调用
                                if ($scope.vo.signedFileName && $scope.vo.signedFileName !== null && $scope.vo.signedFileName !== '') {
                                    this.$confirm(this.$tx('gwgl.messages.haveGz', '该公文已经盖章，重新编辑正文后需要重新盖章！') + '<br>' + this.$tx('gwgl.messages.haveGz2', '是否继续？'), this.$tx('common.confirmOperate', '确认操作'), { type: 'warning', dangerouslyUseHTMLString: true })
                                        .then(() => {
                                            this.btnOpenWordClick($scope, 'RedliningOnce')
                                        })
                                        .catch(() => {
                                            // 处理选择否的情况
                                            $scope.embeddedEditorToggle(false)
                                            return
                                        })
                                } else {
                                    if ($scope.wfInstance.haveDoc === 2) {
                                        // 再次套红  secondRed
                                        this.$confirm(this.$tx('gwgl.messages.haveTh', '该公文已经套过红！') + `<br>` + this.$tx('gwgl.messages.haveGz2', '是否继续？'), this.$tx('common.confirmOperate', '确认操作'), { type: 'warning', dangerouslyUseHTMLString: true })
                                            .then(() => {
                                                this.btnOpenWordClick($scope, 'Redlining')
                                            })
                                            .catch(() => {
                                                // 处理选择否的情况
                                                $scope.embeddedEditorToggle(false)
                                                return
                                            })
                                    } else {
                                        this.btnOpenWordClick($scope, 'Redlining')
                                    }
                                }
                            } else {
                                $scope.embeddedEditorToggle(false)
                            }
                        },
                        $scope.vo.gwmbId,
                        this.$tx('gwgl.components.gwType', '公文类型'),
                        this.$tx('gwgl.components.selectNewGw', '请选择新的公文类型：')
                    )
                } else {
                    $scope.embeddedEditorToggle(false)
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        btnOpenWordClick($scope, openType, fanwen_url) {
            // 编辑文本打开事件
            console.log(openType, 'openType')

            this.openType = openType
            $scope.formValidate(() => {
                const bookmarks = []
                let downUrl = ''

                // if ($scope.vo.fileName === null) { // 初始无正文
                //     downUrl = 'templates/Editor.doc'
                // } else { // 有正文

                //     downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + $scope.vo.passenger.attachments.busiDataId + '&attachsName=' + $scope.vo.passenger.attachments.originalName
                // }

                // if (downUrl.indexOf('/Editor.doc') === -1) {
                //     downUrl += '&saveAs=' + $scope.vo.id + '.doc'
                // }   apigw/gwgl/fwmb/download?id=147ff9d7c97447b6917700d0ff60ce51&dataField=fileContent&nameField=mbFileName&httpPort=2028
                downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + this.vo.id + '&dataField=fileContent&nameField=mbFileName'
                const data = {}

                if (this.officeType === 'ech5') {
                    this.btnOpenEcdocEditorClick($scope, bookmarks, data, downUrl, '', '', openType)
                }
            })
        },
        async btnOpenEcdocEditorClick($scope, bookmarks, data, downUrl, fileId, fileVer, openType) {
            const _this = this
            const appUrl = location.href.split('#')[0].split('windex.html')[0]
            downUrl = appUrl + downUrl

            const fileName = $scope.vo.mbFileName
            const attachType = 'ATTACH'

            downUrl += '&attachsType=' + attachType
            // const msg = '正在下载文件，请稍候...'
            const msg = this.$tx('gwgl.components.isLoading', '正在下载文件，请稍候...')

            this.$bus.emit('showDoingDialog', msg)

            this.$http({
                method: 'GET',
                url: 'wopi/getAccessToken',
                params: { downUrl: downUrl, fileName: fileName }
            }).then((res) => {
                if (res.code === 'success') {
                    this.tSessionId = res.body.tSessionId

                    let editorUrl = res.body.editorUrl
                    if (editorUrl.indexOf('lang=') < 0) {
                        editorUrl += '&lang=zh-CN'
                    }

                    console.log(editorUrl, 'editorUrl  ---- 235')
                    this.editorUrl = editorUrl
                    let docEditor
                    new Promise((resolve, reject) => {
                        _this.$nextTick(() => {
                            this.ecweboffice = true
                            _this.$nextTick(() => {
                                docEditor = _this.$refs.ecweboffice
                                if (docEditor) {
                                    resolve(true)
                                }
                            })
                        })
                    }).then((result) => {
                        if (!result) return
                        this.$bus.emit('closeDoingDialog')
                        // const reloadMsg = '正在保存附件,请稍候...'
                        const reloadMsg = this.$tx('gwgl.components.loadingSave', '正在保存附件,请稍候...')
                        this.doctimer = setInterval(() => {
                            if (!this.ecweboffice && !this.waiting) {
                                clearInterval(this.doctimer)

                                if (window.fileStatus > 0) {
                                    this.$bus.emit('showDoingDialog', reloadMsg)

                                    const uploadUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/upload'

                                    this.checkEcincEditorFinished($scope, res.body.attachId, uploadUrl, 0, '')
                                }
                            }
                            // 在线编辑代码结束
                            if (!this.ecweboffice) {
                                clearInterval(this.doctimer)
                                this.btnEcdocSavedClick(true)
                            }
                        }, 500)
                    })
                    let uploadUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/upload'
                    uploadUrl += '?id=' + $scope.vo.id
                    uploadUrl += '&dataField=fileContent'
                    uploadUrl += '&nameField=mbFileName'
                    uploadUrl += '&method=put'

                    document.querySelector('#btnEcdocSaved').uploadUrl = uploadUrl

                    console.log(document.querySelector('#btnEcdocSaved'), 'btnEcdocSaved')
                    document.querySelector('#btnEcdocSaved').checkSave = false
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        btnEcdocSavedClick(closed) {
            if (this.officeType !== 'ech5') return

            const messageBtn = document.querySelector('#btnEcdocSaved')
            console.log(messageBtn.srcEvent)
            if (!messageBtn.srcEvent) return
            var msg = messageBtn.srcEvent.data
            if (!msg) {
                return
            } else if (typeof msg === 'string') {
                msg = JSON.parse(msg)
            }
            let checkSave = false

            if (closed && messageBtn.checkSave) {
                checkSave = true
            } else if (msg.MessageId === 'UI_Save' || msg.MessageId === 'Action_Save_Resp') {
                checkSave = true
            } else if (msg.MessageId === 'Doc_ModifiedStatus' && msg.Values.Modified) {
                messageBtn.checkSave = false
                return
            }
            if (checkSave && !this.waiting) {
                delete messageBtn.srcEvent.data
                delete messageBtn.checkSave

                const uploadUrl = document.querySelector('#btnEcdocSaved').uploadUrl

                // let reloadMsg = '正在重新加载文件，请稍候...'
                let reloadMsg = this.$tx('gwgl.components.reloadFile', '正在重新加载文件，请稍候')
                let attachType = 'BODY'

                if (uploadUrl.indexOf('=ATTACH') !== -1) {
                    reloadMsg = this.$tx('gwgl.components.loadingSave', '正在保存附件,请稍候...')

                    attachType = 'ATTACH'
                }
                this.$bus.emit('showDoingDialog', reloadMsg)
                const $scope = this.$vnode.context

                this.checkEcincEditorFinished($scope, this.tSessionId, uploadUrl, 0, attachType)
            } else {
                this.$bus.emit('closeDoingDialog')
            }
        },
        checkEcincEditorFinished($scope, fileId, uploadUrl, checkCount, attachType) {
            this.waiting = true
            this.$http({
                method: 'GET',
                url: 'wopi/checkFinished',
                params: { fileId: fileId, uploadUrl: uploadUrl, checkCount: checkCount }
            }).then((chkRes) => {
                if (chkRes.code === 'success') {
                    if (chkRes.body.waiting) {
                        setTimeout(() => {
                            this.waiting = true
                            this.checkEcincEditorFinished($scope, fileId, uploadUrl, ++checkCount, attachType)
                        }, 1000)
                    } else if (chkRes.body.finished) {
                        this.waiting = false
                        this.$bus.emit('closeDoingDialog')
                    } else if (chkRes.body.saved) {
                        this.waiting = false
                        $scope.InlineTextEditorShow = false
                        $scope.btnSubmitClick($scope.actionType)
                    }
                } else {
                    this.$bus.emit('closeDoingDialog')
                    // this.$alert(chkRes.message, this.$tx('common.operationTip','操作提示'), { type: 'error' })
                }
            })
        },
        getSessionId() {
            return new Promise((resolve, reject) => {
                this.$http({
                    method: 'GET',
                    params: { timeLength: 60 },
                    url: 'base/user/getSessionId'
                }).then((res) => {
                    if (res.code === 'success') {
                        resolve(res.body.tSessionId)
                    } else {
                        reject(res.msg)
                    }
                })
            })
        },
        // 返回图片路径
        imgUrl(item) {
            // 文件类型
            var extension = item.oriangialName || item.fileName
            extension = extension.substring(extension.lastIndexOf('.'))
            if (extension === '.doc' || extension === '.docx') {
                return 'images/w-imgs/email/word.png'
            }
            if (extension === '.ppt' || extension === '.pptx') {
                return 'images/w-imgs/email/ppt.png'
            }
            if (extension === '.xls' || extension === '.xlsx') {
                return 'images/w-imgs/email/excel.png'
            }
            if (extension === '.pdf') {
                return 'images/w-imgs/email/pdf.png'
            }
            if (extension === '.txt') {
                return 'images/w-imgs/email/txt.png'
            } else if (extension === '.audio' || extension === '.amr' || extension === '.mp3' || extension === '.wav') {
                return 'images/w-imgs/email/audio.png'
            } else if (extension === '.video' || extension === '.mp4' || extension === '.mov') {
                return 'images/w-imgs/email/video.png'
            } else if (extension === '.zip' || extension === '.rar') {
                return 'images/w-imgs/email/zip.png'
            } else if (extension === '.image' || extension === '.mp4' || extension === '.jpg' || extension === '.jpeg' || extension === '.png' || extension === '.gif' || extension === '.bmp' || extension === '.svg') {
                return 'images/w-imgs/email/picture.png'
            } else if (extension === ' ') {
                return 'images/w-imgs/email/none.png'
            } else {
                return 'images/w-imgs/email/其他.png'
            }
        }
    }
}
</script>

  <style scoped lang="scss">
.bottombar {
    position: absolute;
    background-color: #f1f1f1;
    height: 4px;
    width: 100%;
    margin-top: -4px;
}
#bodyfilebox {
    height: calc(100vh - 74px);
    border: 0px;
    text-align: center;
    font-size: 16px;
    .bodyfile {
        height: 100%;
        width: 100%;
    }
}
.nobodyfile {
    background-color: #fff;
    height: calc(100% - 10px);
    margin: auto;

    .nofile {
        width: 76px !important;
        height: 76px !important;
        margin-top: 100px;
        opacity: 0.5;
    }

    .filename {
        display: inline-block;
        font-size: 18px;
        font-weight: 600;
        width: 90%;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 20px;
    }
}
@media (max-width: 1569px) {
    .nobodyfile {
        width: 980px;
    }
}
@media (min-width: 1570px) {
    .nobodyfile {
        width: 1200px;
    }
}
</style>./ModuleTextEditor.vue
